/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Personal Health Record API
 * API for PHR
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";
import { PhrMedicine, PhrMedicineFromJSON, PhrMedicineFromJSONTyped, PhrMedicineToJSON } from "./";

export const PhrMedicalTreatmentTypename = "PhrMedicalTreatment" as const;

/**
 *
 * @export
 * @interface PhrMedicalTreatment
 */
export interface PhrMedicalTreatment {
  /**
   *
   * @type {string}
   * @memberof PhrMedicalTreatment
   */
  dispenseTime?: string;
  /**
   *
   * @type {string}
   * @memberof PhrMedicalTreatment
   */
  importType: PhrMedicalTreatmentImportTypeEnum;
  /**
   *
   * @type {Date}
   * @memberof PhrMedicalTreatment
   */
  importedTime?: string;
  /**
   *
   * @type {string}
   * @memberof PhrMedicalTreatment
   */
  inout?: string;
  /**
   *
   * @type {string}
   * @memberof PhrMedicalTreatment
   */
  medicalInstitutionName?: string;
  /**
   *
   * @type {Array<PhrMedicine>}
   * @memberof PhrMedicalTreatment
   */
  medicines?: Array<PhrMedicine>;
  /**
   *
   * @type {string}
   * @memberof PhrMedicalTreatment
   */
  prescriptionMedicalInstitutionName?: string;
  /**
   *
   * @type {string}
   * @memberof PhrMedicalTreatment
   */
  prescriptionTime?: string;
  /**
   *
   * @type {string}
   * @memberof PhrMedicalTreatment
   */
  yearMonth?: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PhrMedicalTreatment
   */
  readonly __typename?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum PhrMedicalTreatmentImportTypeEnum {
  Myna = "myna",
  File = "file",
}

export function PhrMedicalTreatmentFromJSON(json: any): PhrMedicalTreatment {
  return PhrMedicalTreatmentFromJSONTyped(json, false);
}

export function PhrMedicalTreatmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhrMedicalTreatment {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PhrMedicalTreatmentTypename,

    dispenseTime: !exists(json, "dispense_time") ? undefined : json["dispense_time"],
    importType: json["import_type"],
    importedTime:
      !exists(json, "imported_time") ||
      (typeof json["imported_time"] === "string" && json["imported_time"].substring(0, 4) === "0001")
        ? undefined
        : json["imported_time"],
    inout: !exists(json, "inout") ? undefined : json["inout"],
    medicalInstitutionName: !exists(json, "medical_institution_name") ? undefined : json["medical_institution_name"],
    medicines: !exists(json, "medicines") ? undefined : (json["medicines"] as Array<any>).map(PhrMedicineFromJSON),
    prescriptionMedicalInstitutionName: !exists(json, "prescription_medical_institution_name")
      ? undefined
      : json["prescription_medical_institution_name"],
    prescriptionTime: !exists(json, "prescription_time") ? undefined : json["prescription_time"],
    yearMonth: !exists(json, "year_month") ? undefined : json["year_month"],
  };
}

export function PhrMedicalTreatmentToJSON(object?: PhrMedicalTreatment | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    dispense_time: value.dispenseTime,
    import_type: value.importType,
    imported_time: value.importedTime === undefined ? undefined : tzDate(value.importedTime).format(),
    inout: value.inout,
    medical_institution_name: value.medicalInstitutionName,
    medicines: value.medicines === undefined ? undefined : (value.medicines as Array<any>).map(PhrMedicineToJSON),
    prescription_medical_institution_name: value.prescriptionMedicalInstitutionName,
    prescription_time: value.prescriptionTime,
    year_month: value.yearMonth,
  };
}
